module.exports = __webpack_public_path__ + "static/iphone-595243ec5f64f508909a8efb8e1be1d4.png";